import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {ITeam} from '@signal/asp-data-commons';

export enum TeamActionTypes {
  LOAD_TEAMS = '[Teams page] Load teams',
  LOAD_TEAMS_NO_OP = '[Teams effects] Load teams no operation done',
  LOAD_TEAMS_SUCCESS = '[Employee API] Load teams success',
  LOAD_TEAMS_FAILURE = '[Employee API] Load teams failure',
  ADD_TEAM = '[Teams page] Add a new team',
  ADD_TEAM_SUCCESS = '[Employee API] Add a new team success',
  ADD_TEAM_FAILURE = '[Employee API] Add a new team failure',
  UPDATE_TEAM = '[Teams page] Update a team',
  UPDATE_TEAM_SUCCESS = '[Employee API] Update a team success',
  UPDATE_TEAM_FAILURE = '[Employee API] Update a team failure',
  DELETE_TEAM = '[Teams page] Delete a team',
  DELETE_TEAM_SUCCESS = '[Employee API] Delete a team success',
  DELETE_TEAM_FAILURE = '[Employee API] Delete a team failure',
  UPDATE_EMPLOYEE_DETAILS = '[Teams page] Update the employee details of the team',
  UPDATE_EMPLOYEES_DETAILS = '[Teams page] Update the employees details of the team',
  UPDATE_EMPLOYEE_DETAILS_SUCCESS = '[Employee API] Update the employee details of the team success',
  UPDATE_EMPLOYEE_DETAILS_FAILURE = '[Employee API] Update the employee details of the team failure',
}

/* ----------------------- LOAD TEAMS ----------------------- */

export class LoadTeams implements Action {
  readonly type: string = TeamActionTypes.LOAD_TEAMS;

  constructor(public payload: { forceReload: boolean } = {forceReload: false}) {
  }
}

export class LoadTeamsNoOp implements Action {
  readonly type: string = TeamActionTypes.LOAD_TEAMS_NO_OP;

  constructor() {
  }
}

export class LoadTeamsSuccess implements Action {
  readonly type = TeamActionTypes.LOAD_TEAMS_SUCCESS;

  constructor(public payload: { teams: ITeam[] }) {
  }
}

export class LoadTeamsFail implements Action {
  readonly type = TeamActionTypes.LOAD_TEAMS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

/* ----------------------- ADD TEAM ----------------------- */

export class AddTeam implements Action {
  readonly type: string = TeamActionTypes.ADD_TEAM;

  constructor(public payload: { team: Partial<ITeam> }) {
  }
}

export class AddTeamSuccess implements Action {
  readonly type = TeamActionTypes.ADD_TEAM_SUCCESS;

  constructor(public payload: { team: ITeam }) {
  }
}

export class AddTeamFail implements Action {
  readonly type = TeamActionTypes.ADD_TEAM_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

/* ----------------------- UPDATE TEAM ----------------------- */

export class UpdateTeam implements Action {
  readonly type: string = TeamActionTypes.UPDATE_TEAM;

  constructor(public payload: { teamUpdate: Update<ITeam>}) {
  }
}

export class UpdateTeamSuccess implements Action {
  readonly type = TeamActionTypes.UPDATE_TEAM_SUCCESS;

  constructor(public payload: { team: ITeam  }) {
  }
}

export class UpdateTeamFail implements Action {
  readonly type = TeamActionTypes.UPDATE_TEAM_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

/* ----------------------- DELETE TEAM ----------------------- */

export class DeleteTeam implements Action {
  readonly type: string = TeamActionTypes.DELETE_TEAM;

  constructor(public payload: { id: string }) {
  }
}

export class DeleteTeamSuccess implements Action {
  readonly type = TeamActionTypes.DELETE_TEAM_SUCCESS;

  constructor(public payload: { team: ITeam }) {
  }
}

export class DeleteTeamFail implements Action {
  readonly type = TeamActionTypes.DELETE_TEAM_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

/* ------- UPDATE EMPLOYEE DETAILS IN TEAM ------------ */

export class UpdateEmployeeDetails implements Action {
  readonly type = TeamActionTypes.UPDATE_EMPLOYEE_DETAILS;

constructor(public payload: { teamUpdate: ITeam[] }) {
  }
}

export class UpdateEmployeeDetailsSuccess implements Action {
  readonly type = TeamActionTypes.UPDATE_EMPLOYEE_DETAILS_SUCCESS;

  constructor(public payload: { teams: ITeam[] }) {
  }
}

export class UpdateEmployeeDetailsFail implements Action {
  readonly type = TeamActionTypes.UPDATE_EMPLOYEE_DETAILS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export type TeamActions =
  | LoadTeams
  | LoadTeamsNoOp
  | LoadTeamsSuccess
  | LoadTeamsFail
  | UpdateEmployeeDetails
  ;
